import React, { useContext, useEffect, useState } from 'react';
import styles from './GrandPage.module.scss';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import { getCurrentVariant, removeFirstSlashes, removeLastSlashes, sanitizeType } from 'functions';
import { useLocation } from 'react-router-dom';
import { DataContext } from '../../../../views/pages/Root';

const GrandPage = ({ properties, animationData, type, blockID }) => {
  const [isFirstOnPage, setIsFirstOnPage] = useState(false);
  const location = useLocation();
  const data = useContext(DataContext);

  useEffect(() => {
    let locationName = location.pathname.charAt(0) == '/' ? location.pathname.slice(1) : location.pathname;
    locationName = locationName.normalize('NFD').replace(/\p{Diacritic}/gu, '');

    // console.log(data, !!data?.pages, locationName);

    const currentPage =
      !!data?.pages?.length &&
      data.pages.find((page) => {
        const tempSlug = page?.slug && page.slug.trim();
        const currentPath = locationName.trim();
        // console.log(tempSlug, currentPath);
        return (
          !!tempSlug &&
          (tempSlug == currentPath ||
            removeLastSlashes(tempSlug) == removeLastSlashes(currentPath) ||
            removeLastSlashes(removeFirstSlashes(tempSlug)) == removeLastSlashes(currentPath))
        );
      });
    if (!!currentPage && !!currentPage?.blocks?.length && currentPage.blocks[0].id == blockID) {
      setIsFirstOnPage(true);
    }
  }, []);

  return (
    (isFirstOnPage || !!properties?.description) && (
      <div
        // data-aos={animationData?.animation}
        // data-aos-offset={animationData?.animationOffset}
        // data-aos-delay={animationData?.animationDelay}
        // data-aos-duration={animationData?.animationDuration}
        // data-aos-easing={animationData?.animationEasing}
        className={`${styles.grandPage} ${sanitizeType(type, styles)}`}
      >
        <div className={styles.firstBox}>{isFirstOnPage && <Breadcrumbs />}</div>
        {!!properties?.description && (
          <div
            data-aos={animationData?.animation}
            data-aos-offset={animationData?.animationOffset}
            data-aos-delay={animationData?.animationDelay}
            data-aos-duration={animationData?.animationDuration}
            data-aos-easing={animationData?.animationEasing}
            className={styles.boxDesc}
          >
            <p className={styles.boxDescTxt}>{properties.description}</p>
          </div>
        )}
      </div>
    )
  );
};

export default GrandPage;
